import { render, staticRenderFns } from "./ModalFicheClientDossier.vue?vue&type=template&id=3938220f"
import script from "./ModalFicheClientDossier.vue?vue&type=script&lang=js"
export * from "./ModalFicheClientDossier.vue?vue&type=script&lang=js"
import style0 from "./ModalFicheClientDossier.vue?vue&type=style&index=0&id=3938220f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports